import { render, staticRenderFns } from "./BudgetHistoryChart.vue?vue&type=template&id=bc989e90&"
import script from "./BudgetHistoryChart.vue?vue&type=script&lang=ts&"
export * from "./BudgetHistoryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports